module.exports = __webpack_public_path__ + "static/media/arrowDown.644044d6.svg";